import { Flex, Text } from '@mantine/core';

interface Props {
	displayName: string;
	email: string;
	emailDataTestId?: string;
}

export const InvestorColumnSummary = ({ displayName, email, emailDataTestId }: Props) => (
	<Flex direction="column" w="100%">
		<Text truncate lineClamp={1} style={{ wordBreak: 'break-word' }}>
			{displayName}
		</Text>
		<Text c="dark.0" truncate lineClamp={1} data-testid={emailDataTestId}>
			{email}
		</Text>
	</Flex>
);
